import { NavBar } from 'components/layout/nav-bar';
import { PATHS } from 'components/main/paths';
import { AuthContext } from 'contexts/auth';
import { DialogType } from 'enums/dialog';
import { NavBarItem } from 'interfaces/layout/nav-bar';
import { RouteDef } from 'interfaces/layout/route';
import { useContext, useMemo } from 'react';

const routeToNavBarItem = (route: RouteDef) => {
  const output: NavBarItem = {
    label: route.label,
    href: `/${route.path}`,
    color: route.color,
  };

  return output;
};

export const UserNav = () => {
  const { user, logout, setDialog } = useContext(AuthContext);

  const navBarItems = useMemo(() => {
    if (!user) {
      return [];
    }

    if (user.isInvestor) {
      return PATHS.INVESTOR.map((r) => routeToNavBarItem(r));
    }

    const output: NavBarItem[] = [
      user.isAdmin ? PATHS.ADMIN : [],
      user.isAdmin || user.isDealer ? PATHS.DEALER : [],
    ].flatMap((rs) => rs.map((r) => routeToNavBarItem(r)));

    return output;
  }, [user]);

  return (
    <NavBar
      start={navBarItems}
      end={[
        {
          label: 'Profile',
          onClick: () => setDialog(DialogType.Update),
        },
        {
          label: 'Logout',
          onClick: () => logout(),
        },
      ]}
    />
  );
};
